import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { selectListItems as selectLibraryListItems } from "../../../../../redux/library/selector";
import { selectOrdersCreatedItem, selectOrdersCurrentItem } from "../../../../../redux/orders/selector";
import { selectQuotesCreatedItem as selectCreateQuoteDetails } from "../../../../../redux/quotes/selector";
import moment from "moment";
import { RadioGroup } from "@headlessui/react";
import _ from "lodash";
import { quotes } from "../../../../../redux/quotes/action";
import storePersist from "../../../../../redux/storePersist";
import { addPayment } from "../../../../../redux/addPayment/action";
import { orders } from "../../../../../redux/orders/action";
import { shippingTypes } from "../../../../../redux/shippingTypes/action";
import { leads } from "../../../../../redux/leads/action";
import { selectShippingTypesListItems } from "../../../../../redux/shippingTypes/selector";
import { selectLeadsCreatedItem, selectLeadsListItems } from "../../../../../redux/leads/selector";
import { useNavigate } from "react-router-dom";
import { selectCategoriesListItems } from "../../../../../redux/categories/selector";
import { categories } from "../../../../../redux/categories/action";
import { selectProductsListItems } from "../../../../../redux/products/selector";
import { products } from "../../../../../redux/products/action";
import { selectVariantsListItems } from "../../../../../redux/variants/selector";
import { variants } from "../../../../../redux/variants/action";
import { selectShippingProvidersListItems } from "../../../../../redux/shipping-providers/selector";
import { shippingProviders } from "../../../../../redux/shipping-providers/action";
import { selectOrganizationUnitsListItems } from "../../../../../redux/organizationUnits/selector";
import useWindowDimensions from "../../../../../hooks/useWindowsDimensions";
import { paymentMethods } from "../../../../../redux/payment-methods/action";
import { selectPaymentMethodsQueryItems } from "../../../../../redux/payment-methods/selector";
import { channel } from "../../../../../redux/channel/action";
import queryString from "query-string";
import CryptoJS from 'crypto-js';
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCurrent, selectSettings } from "../../../../../redux/settings/selectors";
import { selectCmsSettingsListItems } from "../../../../../redux/cmsSettings/selector";
import GoogleMapSearch from "../../../../../common/components/google-map-search";
import { getFormattedDate } from "../../../../../common/services/common.service";
import { toast } from "react-toastify";
import { selectCustomersListItems } from "../../../../../redux/customers/selector";
import { InputContainer } from "../../../../../common/components/form/form.module";
import { customers } from "../../../../../redux/customers/action";
import { RotatingLines } from "react-loader-spinner";
import ParcelBasicInfoComponent from "./parcel-basic-info";
import ShipmentInfoComponent from "./shipment-info";
import LocationInfoComponent from "./location-info";
import PaymentInfoComponent from "./payment-info";
import MobileFileUploadComponent from "../../../../../common/components/mobile-file-upload.component";
declare let Razorpay: any;
let currentChange: any = {};
const ParcelBookings = () => {

	interface ISteps {
		CategoryName: string;
		ItemName: string
		PackageType: string
		Weight: string
		Width: string
		Height: string
		Length: string
		AdditionalInfo: string
		NumberOfItems: number
	}
	// interface IPackage {
	// 	package: string
	// }
	const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
	const [isLead, setIsLead] = useState<boolean>(false)
	const [isQuotes, setIsQuotes] = useState<boolean>(false)
	const dispatch = useAppDispatch();
	const result = useSelector(selectCurrent)
	const defaultSetting = useSelector(selectSettings)
	const { header, footer, visible, sidebar, theme, primary, secondary } = defaultSetting
	const organizationUnitLists = useSelector(selectOrganizationUnitsListItems)
	const leadDetails = useSelector(selectLeadsListItems)
	const createLead = useSelector(selectLeadsCreatedItem)
	const quoteDetails = useSelector(selectCreateQuoteDetails)
	const paymentSettings = useSelector(selectCmsSettingsListItems)
	const libraryData = useSelector(selectLibraryListItems)
	const shippingTypesDetails = useSelector(selectShippingTypesListItems)
	const categoryListItems = useSelector(selectCategoriesListItems)
	const ProductLists = useSelector(selectProductsListItems)
	const variantLists = useSelector(selectVariantsListItems)
	const [isOrderTriggered, setIsOrderTriggered] = useState(false)
	const [isInitiateRazorpayTriggered, setIsInitiateRazorpayTriggered] = useState(false)
	const [totalValue, setTotalValue] = useState(0);
	const [isPaymentAdded, setIsPaymentAdded] = useState<any>(false);
	const [quoteData, SetQuoteData] = useState<any>({});
	const navigate = useNavigate()
	const [leadValues, setLeadValues] = useState<any>()
	const [productCount, setProductCount] = useState([1])
	const [generateIds, setGenerateIds] = useState<any>([]);
	const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems)
	const shippingProvidersListItems = useSelector(selectShippingProvidersListItems)
	const handleChange: any = (event: any, field: string) => {
		setLeadValues({ ...leadValues, [field]: event })
		SetQuoteData({ ...quoteData, [field]: event })
	}
	const customerListData = useSelector(selectCustomersListItems)
	const [paymentGateway, setPaymentGateway] = useState<any>([]);
	const [razorpaySettings, setRazorpaySettings] = useState<any>([])
	const [isOrderPlaced, setIsOrderPlaced] = useState<any>(false);
	const { height, width } = useWindowDimensions();
	const orderDetails = useSelector(selectOrdersCreatedItem)
	const [orderId, setOrderId] = useState<any>()
	var tenantId = storePersist.get('guestTokenMetadata')?.current?.result?.TokenMetadata?.TenantId
	const MODE = 'secure';
	const userProfileData = storePersist?.get("userProfile")?.current?.items[0]?.Message;
	const [
		mediaFiles,
		setMediaFiles
	] = useState<any>()
	var storeId = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.StoreId;
	const [count, setCount] = useState(1)
	const [pickupLocations, setPickupLocation] = useState<any>({
		name: '',
		lat: '',
		lng: '',
		pincode: '',
		description: '',
	});
	const [dropLocations, setDropLocation] = useState<any>({
		name: '',
		lat: '',
		lng: '',
		pincode: '',
		description: '',
	});
	const [selectedInput, setSelectedInput] = useState("");
	const PackageType = [
		{ name: 'Standard Package' },
		{ name: 'Custom Package' }
	]
	const [productItems, setProductItems] = useState<any>([]);

	const addNewItemsRow = ({ selectedItemsArg }: any) => {
		const localSelectediem = JSON.parse(JSON.stringify(selectedItemsArg))
		const newsSelectedItem = {
			Id: 0,
			CategoryId: 0,
			LogisticsProductId: 0,
			quantity: 0,
		};
		if (
			localSelectediem.length === 0 ||
			localSelectediem[localSelectediem?.length - 1]?.CategoryId !==
			0 ||
			localSelectediem[localSelectediem?.length - 1]?.LogisticsProductId !== 0 ||
			localSelectediem[localSelectediem?.length - 1]?.quantity !== 0
		) {
			localSelectediem?.push(newsSelectedItem);
		}

		return localSelectediem;
	};
	const handleFormItemChange: any = ({ value, field, idx }: any) => {
		const items = JSON.parse(JSON.stringify(productItems)) // deep copy of grn items
		let item = items[idx]; // deep copy of item to be edited
		item = { ...item, [field]: value }; // updated the particular item
		items[idx] = item;
		currentChange = { value, field, idx };
		setProductItems(items);
	};

	const setCombinationInfo = async () => {
		let localSelectedItem = JSON.parse(JSON.stringify(productItems));
		localSelectedItem.splice(currentChange.idx, 1, {
			...localSelectedItem[currentChange.idx],
		});
		localSelectedItem = addNewItemsRow({ selectedItemsArg: localSelectedItem });
		currentChange = productCount;

		setProductItems(localSelectedItem);
	};
	// useEffect(() => {
	// 	//fetchShippingTypes();
	// 	// if (data?.isRecurringOrder) {
	// 	//   const selectedProducts =
	// 	// 	data?.itemsData?.ondc_org_linked_order?.items?.map((item) => {
	// 	// 	  const product = {
	// 	// 		category_type_Id: item?.category_id,
	// 	// 		item_name: item?.descriptor?.name,
	// 	// 		item_description: item?.descriptor?.name,
	// 	// 		quantity: item?.quantity?.count,
	// 	// 		weight: item?.quantity?.measure?.value,
	// 	// 	  };
	// 	// 	  return product;
	// 	// 	});
	// 	//   const localSelectedItems = addNewItemsRow({
	// 	// 	selectedItemsArg: selectedProducts,
	// 	//   });
	// 	//   setProductItems(localSelectedItems);
	// 	// } else {
	// 	const localSelectedItems = addNewItemsRow({
	// 		selectedItemsArg: productItems,
	// 	});
	// 	setProductItems(localSelectedItems);
	// 	//}
	// }, []);
	useEffect(() => {
		// if (
		//   currentChange.field === 'category_type_Id' ||
		//   currentChange.field === 'item_name'
		// ) {
		//   setCombinationInfo();
		// }
	}, [productItems]);
	const items = [
		{
			name: 'Cash',
			description: 'Cash on delivery',
			value: 10,
			checked: '',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForParcelCOD,
		},
		{
			name: 'Online',
			description: 'Payment gateway',
			value: 20,
			checked: 'checked',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForParcelOnline,
		},
		{
			name: 'Wallet',
			description: 'Wallet',
			value: 40,
			checked: '',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForWallet,
		},
	];

	const [selected, setSelected] = useState(items[0].value);

	const handleMinus = (index: any, data: any) => {
		handleFormItemChange({
			value: data - 1,
			idx: index,
			field: 'quantity'
		})
	}

	const handlePlus = (index: any, data: any) => {

		handleFormItemChange({
			value: data + 1,
			idx: index,
			field: 'quantity'
		})
	}
	const handlePackage = (e: any) => {

		setSelectedInput(e.target.value)
	}
	const generateUniqueId = () => {
		const randomPart = Math.random().toString(36).substr(2, 9); // Random part
		const timestampPart = Date.now().toString(36); // Timestamp part
		return `${randomPart}-${timestampPart}`;
	};

	const generateIdValue = () => {
		const newItem = {
			transaction_id: generateUniqueId(),
			message_id: generateUniqueId(),
			fulfillment_id: generateUniqueId(),
			item_id: generateUniqueId(),
			order_id: generateUniqueId(),
		};
		setGenerateIds(newItem);
	};
	const handleCustomerSearch = async ({ event }: any) => {
		await dispatch(customers.resetAction({ actionType: 'list' }))
		await dispatch(customers.list({
			url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/sales/crm/logistics-customers/list`, entity: 'customers', jsonData: {
				"Filters": [
					{
						"FieldName": "UserName",
						"FilterOperatorId": 6,
						"FieldValue": event,
						"FieldType": "text"
					}
				],
			}
		}))
	}

	let filterCustomer = _.find(customerListData.result.items, ['Id', leadValues?.CustomerId]);

	const handleAdd = () => {

		setProductCount([...productCount, 1])

		setCombinationInfo()
	}
	const handleDelete = (productItem: any, index: any) => {

		const updatedItems = [...productItems];  // Create a copy of the array
		updatedItems.splice(index, 1);  // Remove the item at the given index
		setProductItems(updatedItems)
	}


	const handleFileURlSubmit = async (urlData) => {

		await setMediaFiles(
			[{
				Id: 0,
				FileTypeId: urlData?.FileType === 'image' ? 10 : 20,
				OwnerId: 0,
				OwnerType: "shipping",
				OwnerTypeId: 1007,
				FileMappingURL: urlData?.DocumentPath
			}]
		)
		await handleNext()

	}
	// Calculate total Product value
	useEffect(() => {
		const sum = productItems
			.filter(item => item.value) // Remove empty objects
			.reduce((sum, item) => sum + Number(item.value), 0);
		setTotalValue(sum);
	}, [productItems]);


	// Check condition
	const isOpenComponent = totalValue >= 50000;


	//components
	const tutorialSteps = [
		{
			id: 1,
			title: 'Basic Details',
			subTitle: 'Basic Details',
			component: (



				<ParcelBasicInfoComponent
					handleCustomerSearch={handleCustomerSearch}
					customerListData={customerListData}
					dropLocations={dropLocations}
					pickupLocations={pickupLocations}
					leadValues={leadValues}
					setPickupLocation={setPickupLocation}
					filterCustomer={filterCustomer}
					handleChange={handleChange}
					setDropLocation={setDropLocation}
				/>




			),
			display: true,
		},
		{
			id: 2,
			title: 'Shipment Details',
			subTitle: 'Shipment Details',
			component: (

				<ShipmentInfoComponent
					handleAdd={handleAdd}
					handlePlus={handlePlus}
					handleMinus={handleMinus}
					variantLists={variantLists}
					ProductLists={ProductLists}
					categoryListItems={categoryListItems}
					handlePackage={handlePackage}
					selectedInput={selectedInput}
					handleFormItemChange={handleFormItemChange}
					PackageType={PackageType}
					productItems={productItems}
					libraryData={libraryData}
					shippingTypesDetails={shippingTypesDetails}
					handleChange={handleChange}
					quoteData={quoteData}
					handleDelete={handleDelete} />




			),
			display: true,
		},
		{
			id: 3,
			title: 'Location Details',
			subTitle: 'Pickup Details',
			component: (

				<LocationInfoComponent
					dropLocations={dropLocations}
					setDropLocation={setDropLocation}
					pickupLocations={pickupLocations}
					setPickupLocation={setPickupLocation}
					libraryData={libraryData}
					handleChange={handleChange}
					quoteData={quoteData}
				/>

			),
			display: true,
		},

		{
			id: 4,
			title: 'Confirm Booking',
			subTitle: 'Order Summary',
			component: (
				<div className="w-full">
					<div className="mb-6 ">
						<h1> Order  Summary Details</h1>

					</div>
					<table className="w-full  font-semibold text-sm lg:text-base">
						<tfoot>
							<tr >
								<td className="p-4 italic">{"Amount Quoted "}</td>
								<td className="p-4"> {quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value}</td>
							</tr>
							<tr >
								<td className="p-4 italic">{"Relocation Date"}</td>
								<td className="p-4">
									{leadDetails?.quoteData?.date ? getFormattedDate(leadDetails?.quoteData?.date) : moment().format('YYYY-MM-DD h:mm:ss a')}
									{/* <span className="text-[13px] font-normal ps-1.5 inline-block">
                via Flat rate
              </span> */}
								</td>
							</tr>
							<tr >
								<td className="p-4 italic">{"Service Type"}</td>
								<td className="p-4">{"Standard"}</td>
							</tr>
							<tr >
								<td className="p-4 italic">{"No of items added"}</td>
								<td className="p-4">{quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.length}</td>
							</tr>


							{/* <tr className="odd:bg-skin-secondary">
            <td className="p-4 italic">{useLocale('common', 'text-note')}:</td>
            <td className="p-4">{useLocale('common', 'text-new-order')}</td>
          </tr> */}
						</tfoot>
					</table>
				</div>
			),
			display: true,
		},
		{
			id: 5,
			title: 'Upload the E-Way Bill',
			subTitle: 'E-Way',
			component: (
				<MobileFileUploadComponent handleFileURlSubmit={handleFileURlSubmit}
					folder='shipping'
					ownerId='0'
				/>
			),
			display: isOpenComponent,
		},
		{
			id: 6,
			title: 'Payment Option',
			subTitle: 'Select payment slot',
			component: (
				<PaymentInfoComponent
					selected={selected}
					setSelected={setSelected}
					items={items}
				/>
			),
			display: true,
		},
	];

	useEffect(() => {
		console.log(isOpenComponent)
		if (!isOpenComponent && tutorialSteps[activeStep]?.display === false && tutorialSteps[activeStep].subTitle === 'E-Way') {

			handleNext();
		}
	}, [tutorialSteps])
	const [activeStep, setActiveStep] = useState(0);
	const maxSteps = tutorialSteps.length;
	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	// const handleSteps = (e: any, key: any) => {
	// 	setSteps({ ...steps, [key]: e.target.value })
	// }

	// const handlePackage = (e: any) => {
	// 	setSelectedInput(e.target.value)
	// }

	useEffect(() => {

	}, [count, selectedInput]);
	useEffect(() => {

	}, [selected])

	useEffect(() => {
		setRazorpaySettings(paymentMethodQuery?.result?.items?.RazorPayConfiguration);
		// setRazorpaySettings([
		// 	{
		// 		"Id": 3,
		// 		"RazorPayConfiguration": {
		// 			"RazorPayConfigurationPId": "97-ORD-JBN-2",
		// 			"StoreId": 183,
		// 			"GatewayName": "RazorPay",
		// 			"GatewayKey": "rzp_test_iS2R7go2pSvdA3",
		// 			"GatewaySecret": "px5DE484H7meoTSsSHepRx14",
		// 			"RazorPay": {
		// 				"GatewayName": "RazorPay",
		// 				"GatewayKey": "00000000",
		// 				"GatewaySecret": "00000000",
		// 				"IsActive": false
		// 			},
		// 			"CCAvenue": {
		// 				"GatewayName": "CCAvenue",
		// 				"WorkingKey": "351280CC07CE5C96BD46FCC3570879B4",
		// 				"MerchantId": "3096301",
		// 				"AccessCode": "AVCN05KL42CE88NCEC",
		// 				"IsActive": true
		// 			},
		// 			"PhonePe": {
		// 				"GatewayName": "PhonePe",
		// 				"SaltKey": "00000000",
		// 				"MerchantId": "00000000",
		// 				"SaltIndex": "00000000",
		// 				"IsActive": false
		// 			},
		// 			"IsActive": true,
		// 			"CreatedOnUtc": "2022-05-12T13:03:39.633",
		// 			"CreatedById": 231,
		// 			"ModifiedOnUtc": "2022-05-12T13:03:39.633",
		// 			"ModifiedById": 231
		// 		}
		// 	}
		// ])
	}, [paymentMethodQuery]);
	useEffect(() => {
		const gateways: any = []
		if (razorpaySettings?.RazorPay?.IsActive) {
			gateways.push({ Id: 10, title: 'Razorpay', detail: 'Razorpay' })
		}
		if (razorpaySettings?.CCAvenue?.IsActive) {

			gateways.push({ Id: 20, title: 'CC Avenue', detail: 'CC Avenue' })
		}
		if (razorpaySettings?.PhonePe?.IsActive) {
			gateways.push({ Id: 30, title: 'PhonePe', detail: 'PhonePe' })
		}
		setPaymentGateway(gateways);
	}, [razorpaySettings]);
	// const handleReset = () => {
	// 	setSteps({
	// 		CategoryName: '', ItemName: '',
	// 		PackageType: '', Weight: '',
	// 		Width: '', Height: '',
	// 		Length: '', AdditionalInfo: '',
	// 		NumberOfItems: 0

	// 	})
	// }

	// Step 1: Submit Lead
	const handleLeadSubmit = async (event: any) => {
		event?.preventDefault()
		// Validation for required fields
		if (
			// !userInfo[0]?.Message?.FirstName ||
			// !userInfo[0]?.Message?.PhoneNumber ||
			!leadValues?.date ||
			!pickupLocations?.description ||
			!dropLocations?.description
		) {
			toast.error("All fields are required. Please fill in all the details.");
			return; // Stop further execution if validation fails
		}

		// Parse addresses
		const fromAddressData = _.split(pickupLocations?.description, ',');
		const toAddressData = _.split(dropLocations?.description, ',');

		// Dispatch actions if validations pass
		try {
			await setIsButtonLoading(true)
			await dispatch(leads.resetAction({ actionType: 'create' }))
			if (pickupLocations?.description !== dropLocations?.description) {
				await dispatch(leads.create({
					url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads`, entity: 'leads', jsonData: {
						Records: [
							{
								Context: {
									transaction_id: generateIds?.transaction_id,
									message_id: generateIds?.message_id,
								},
								Message: {
									LeadInfo: {
										Name: leadValues?.IsExistingUser ? filterCustomer?.AccountName : leadValues?.Name,
										Email: leadValues?.IsExistingUser ? filterCustomer?.Email : leadValues?.Email,
										PhoneNumber: leadValues?.IsExistingUser ? filterCustomer?.PhoneNumber : leadValues?.PhoneNumber,
										date: leadValues?.date,
										Description: leadValues?.Description,
										IsExistingUser: leadValues?.IsExistingUser,
										LeadPayload: {
											weight: {
												unit: '',
												value: leadValues?.weight || 0
											},
											dimensions: {
												length: {
													unit: '',
													value: leadValues?.length || 0
												},
												breadth: {
													unit: '',
													value: leadValues?.breadth || 0
												},
												height: {
													unit: '',
													value: leadValues?.height || 0
												}
											},
											category: '',
											value: {
												currency: 'INR',
												value: 0
											},
											dangerous_goods: false
										},
										start: {
											location: {
												gps: `${pickupLocations?.lat},${pickupLocations?.lng}`,
												address: {
													name: pickupLocations?.name,
													building: pickupLocations?.description,
													locality: `${fromAddressData[0]},${fromAddressData[1]}`,
													city: pickupLocations?.name,
													state: fromAddressData[3],
													country: 'India',
													area_code: pickupLocations?.pincode,
												},
											},
										},

										end: {
											location: {
												gps: `${dropLocations?.lat},${dropLocations?.lng}`,
												address: {
													name: dropLocations?.name,
													building: dropLocations?.description,
													locality: `${toAddressData[0]},${toAddressData[1]}`,
													city: dropLocations?.name,
													state: toAddressData[3],
													country: 'India',
													area_code: dropLocations?.pincode,
												},
											},
										},
									}
								}

							}
						]
					}
				}))
				await setIsLead(true)
				await setIsButtonLoading(false)
			}
			else {
				toast.error("The Pickup and Drop addresses must be different.")
			}
		} catch (error) {
			toast.error("An error occurred while submitting the form. Please try again.");
		};
	}

	useEffect(() => {
		if (isLead && createLead?.isSuccess) {
			handleNext();
			setIsLead(false)
		}
	}, [isLead])

	// Step 2: Submit Quotes
	const handleSaveQuote = async () => {

		// Validation for required fields
		const invalidItem = productItems.find(item => {
			return !item?.weight || !item?.LogisticsProductId || !item?.quantity || !item?.CategoryId || !item?.LogisticsVariantId; // Replace with your required conditions
		});
		if (
			!quoteData?.category_id ||
			!quoteData?.code ||
			invalidItem ||
			!pickupLocations?.description ||
			!dropLocations?.description
		) {
			toast.error("All fields are required. Please fill in all the details.");
			return; // Stop further execution if validation fails
		}

		let shippingType = _.find(shippingTypesDetails.result.items, ['ShippingTypeName', quoteData.category_id]);
		const fromAddressData = _.split(pickupLocations?.description, ',');
		const toAddressData = _.split(dropLocations?.description, ',');
		const selectedProducts = productItems?.map((item: any) => {
			const product = {
				CategoryId: item?.CategoryId,
				LogisticsProductId: item?.LogisticsProductId,
				LogisticsVariantId: item?.LogisticsVariantId,
				quantity: {
					count: item?.quantity,
					measure: {
						unit: "kg",
						value: item?.measure || 0
					}
				},
				weight: {
					unit: "mm",
					value: item?.weight || 0
				},
				dimensions: {
					length: {
						unit: "mm",
						value: item?.Length || 0
					},
					breadth: {
						unit: "mm",
						value: item?.breadth || 0
					},
					height: {
						unit: "mm",
						value: item?.Height || 0
					}
				},
				value: {
					currency: "INR",
					value: item?.value || 0
				},
				dangerous_goods: item?.dangerous_goods
			}

			return product;
		});
		const valueData = {
			order: {
				provider: {
					id: shippingProvidersListItems?.result?.items[0]?.AccountPId,
					locations: []
				},
				items:
					[{
						id: String(shippingType.Id),
						fulfillment_id: generateIds?.fulfillment_id,
						category_id: quoteData?.category_id,
						descriptor: {
							code: quoteData?.code
						},
						time: {
							label: "",
							duration: "",
							timestamp: leadValues?.date || ""
						}
					}],
				billing: {},
				payment: {},
				LinkedItems: selectedProducts,
				fulfillments: [
					{
						id: generateIds?.fulfillment_id,
						type: quoteData?.type,
						start: {
							location: {
								gps: `${pickupLocations?.lat} ,${pickupLocations?.lng}`,
								address: {
									name: quoteData?.pickupName,
									building: quoteData?.startBuilding,
									locality: `${fromAddressData[0]},${fromAddressData[1]}`,
									city: pickupLocations?.name,
									state: fromAddressData[3] || 'TamilNadu',
									country: 'India',
									area_code: pickupLocations?.pincode || ''
								}
							},
							contact: {
								phone: leadValues?.IsExistingUser ? filterCustomer?.PhoneNumber : quoteData?.pickupPhoneNumber,
								email: leadValues?.IsExistingUser ? filterCustomer?.Email : leadValues?.Email
							}
						},
						end: {
							location: {
								gps: `${dropLocations?.lat} ,${dropLocations?.lng}`,
								address: {
									name: quoteData?.dropName,
									building: quoteData?.endBuilding,
									locality: `${toAddressData[0]},${toAddressData[1]}`,
									city: dropLocations?.name,
									state: toAddressData[3] || 'TamilNadu',
									country: 'India',
									area_code: dropLocations?.pincode || ''
								}
							},
							contact: {
								phone: quoteData?.dropPhoneNumber,
								email: ''
							}
						}
					}
				]
			}
		}
		await setIsButtonLoading(true)
		await dispatch(quotes.resetAction({ actionType: 'create' }))
		if (pickupLocations?.description !== dropLocations?.description) {
			await dispatch(quotes.create({
				url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes`, entity: 'quotes',
				jsonData: {
					Records: [{
						context: {
							transaction_id: createLead?.result?.Records[0]?.Context?.transaction_id,
							message_id: generateIds?.item_id,
						},
						message: valueData,
					}]
				}
			}))
			await setLeadValues({});
			await setIsQuotes(true)
			await setIsButtonLoading(false)
		} else {
			toast.error("The Pickup and Drop addresses must be different.")
		}
	}

	useEffect(() => {

		if (isQuotes && quoteDetails?.isSuccess) {
			setPickupLocation({
				name: '',
				lat: '',
				lng: '',
				pincode: '',
				description: ''
			})
			setDropLocation({
				name: '',
				lat: '',
				lng: '',
				pincode: '',
				description: ''
			})
			setIsQuotes(false)
			handleNext();
		}
	}, [isQuotes])

	// Step 3: Add Payment
	const handleOrder = async () => {
		await setIsButtonLoading(true)
		await dispatch(addPayment.update({
			url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/check-outs/add-payment`, entity: 'addPayment', jsonData: {
				Records: [{
					Context: {
						transaction_id: quoteDetails?.result?.Records[0]?.context?.transaction_id,
						message_id: generateIds?.message_id,
					},
					Message: {
						Id: quoteDetails?.result?.Records[0]?.message?.order?.Id,
						OwnerType: 'LogisticsOrder',
						PaidAmount: quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value,
						PaymentRemarks: 'LogisticsOrder',
						PaymentMethodId: selected, // Number(sessionStorage.getItem('paymentmethod')),
						PaymentGatewayId: paymentGateway[0]?.Id || 0,
					},
				}

				],
			}
		})).then(() => {

			setIsPaymentAdded(true);
		})

	};

	// Step 4: Confirm Logistics Order
	const ConfirmOrder = async () => {
		const itemValues = quoteDetails?.result?.Records[0]?.message?.order?.items?.map((item: any) => {
			const data = {
				id: item?.id,
				fulfillment_id: item?.fulfillment_id,
				category_id: item?.category_id,
				descriptor: {
					code: item?.descriptor?.code
				},
				time: {
					label: null,
					duration: null,
					timestamp: item?.time?.timestamp
				}
			};
			return data;
		});

		const breakupValues = quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup?.map((item: any) => {
			const data = {
				"@ondc/org/item_id": item?.['@ondc/org/item_id'],
				"@ondc/org/title_type": item?.['@ondc/org/title_type'],
				"price": {
					"currency": item?.price?.currency,
					"value": item?.price?.value
				}
			};
			return data;
		});
		const fulfillmentValues = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments?.map((item: any) => {
			const data = {
				"id": item?.id,
				"type": item?.type,
				"@ondc/org/awb_no": null,
				"start": {
					"person": {
						"name": item?.start?.location?.address?.name || ''
					},
					"location": {
						"gps": item?.start?.location?.gps,
						"address": {
							"name": item?.start?.location?.address?.name,
							"building": item?.start?.location?.address?.building,
							"locality": item?.start?.location?.address?.locality,
							"city": item?.start?.location?.address?.city,
							"state": item?.start?.location?.address?.state,
							"country": item?.start?.location?.address?.country,
							"area_code": item?.start?.location?.address?.area_code
						}
					},
					"contact": {
						"phone": item?.start?.contact?.phone,
						"email": item?.start?.contact?.email
					},
					"instructions": {
						"code": null,
						"short_desc": null,
						"long_desc": null,
						"additional_desc": {
							"content_type": null,
							"url": null
						},
						"images": null

					},
					"time": {
						"label": null,
						"duration": null,
						"timestamp": null
					}
				},
				"end": {
					"person": {
						"name": item?.end?.location?.address?.name || ''
					},
					"location": {
						"gps": item?.end?.location?.gps,
						"address": {
							"name": item?.end?.location?.address?.name,
							"building": item?.end?.location?.address?.building,
							"locality": item?.end?.location?.address?.locality,
							"city": item?.end?.location?.address?.city,
							"state": item?.end?.location?.address?.state,
							"country": item?.end?.location?.address?.country,
							"area_code": item?.end?.location?.address?.area_code
						}
					},
					"contact": {
						"phone": item?.end?.contact?.phone || '',
						"email": item?.end?.contact?.email || ''
					},
					"instructions": {
						"code": null,
						"short_desc": null,
						"long_desc": null,
						"additional_desc": {
							"content_type": null,
							"url": null
						},
						"images": null
					},
					"time": {
						"label": null,
						"duration": null,
						"timestamp": null
					}
				},
				"EWayBill": {
					"MediaFiles": isOpenComponent ? mediaFiles : [],
					"Templates": []
				},
				"agent": {},
				"vehicle": {},
				"@ondc/org/ewaybillno": null,
				"@ondc/org/ebnexpirydate": null,
				"tags": [
					{
						"code": null,
						"list": [
							{
								"code": null,
								"value": null
							}
						]
					}
				]
			};
			return data;
		});
		const linkedItemValues = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.map((item: any) => {
			let category = _.find(categoryListItems?.result?.items, ['Id', item?.CategoryId]);
			let product = _.find(ProductLists?.result?.items, ['Id', item?.LogisticsProductId]);
			const data = {
				"CategoryName": category?.Name,
				"CategoryId": item?.CategoryId,
				"LogisticsProductId": item?.LogisticsProductId,
				"LogisticsVariantId": item?.LogisticsVariantId,
				"descriptor": {
					"name": product?.Name
				},
				"quantity": {
					"count": item?.quantity?.count,
					"measure": {
						"unit": item?.quantity?.measure?.unit,
						"value": item?.quantity?.measure?.value
					}
				},

				"price": {
					"currency": item?.value?.currency,
					"value": item?.value?.value
				},
				"dangerous_goods": item?.dangerous_goods
			};
			return data;
		});
		const tagValues = quoteDetails?.result?.Records[0]?.message?.order?.tags?.map((item: any) => {
			const data = {
				code: item?.code,
				list: item?.list?.map((listItem: any) => {
					const data = {
						"code": listItem?.code,
						"value": listItem?.value
					}
					return data;

				})
			};
			return data;
		});
		const orderData = {
			context: {
				transaction_id: createLead?.result?.Records[0]?.Context?.transaction_id,
				message_id: generateIds?.fulfillment_id,
			},
			message: {
				order: {
					created_at: moment.utc(),
					updated_at: moment.utc(),
					id: generateIds.order_id,
					state: null,
					IsCargoOrder: false,
					provider: {
						id: quoteDetails?.result?.Records[0]?.message?.order?.provider?.id,
						locations: quoteDetails?.result?.Records[0]?.message?.order?.provider?.locations
					},
					items: itemValues,
					quote: {
						price: {
							currency: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.currency,
							value: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value,
						},
						breakup: breakupValues
					},
					fulfillments: fulfillmentValues,
					"billing": {
						"name": fulfillmentValues[0]?.start?.person?.name || '',
						"address": {
							"name": fulfillmentValues[0]?.start?.location?.address?.name || '',
							"building": fulfillmentValues[0]?.start?.location?.address?.building || '',
							"locality": fulfillmentValues[0]?.start?.location?.address?.locality || '',
							"city": fulfillmentValues[0]?.start?.location?.address?.city || '',
							"state": fulfillmentValues[0]?.start?.location?.address?.state || '',
							"country": fulfillmentValues[0]?.start?.location?.address?.country || '',
							"area_code": fulfillmentValues[0]?.start?.location?.address?.area_code || '',
						},
						"tax_number": "",
						"phone": fulfillmentValues[0]?.start?.contact?.phone,
						"email": fulfillmentValues[0]?.start?.contact?.email,

					},
					"payment": {
						"@ondc/org/collection_amount": null,
						"collected_by": null,
						"type": null,
						"@ondc/org/settlement_details": [
							{
								"settlement_counterparty": null,
								"settlement_type": null,
								"upi_address": null,
								"settlement_bank_account_no": null,
								"settlement_ifsc_code": null
							}
						]
					},
					"@ondc/org/linked_order": {
						"items": linkedItemValues,
						"provider": {
							"descriptor": {
								"name": null
							},
							"address": {
								"name": organizationUnitLists?.result?.items[0]?.Name,
								"building": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address1,
								"locality": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address2,
								"city": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.City,
								"state": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.StateProvince?.Name,
								"country": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Country?.Name,
								"area_code": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.ZipPostalCode
							}
						},
						"order":
						{
							"id": null,
							"weight": {
								"unit": "mm",
								"value": 600
							},
							"dimensions": {
								"length": {
									"unit": "mm",
									"value": 50
								},
								"breadth": {
									"unit": "mm",
									"value": 60
								},
								"height": {
									"unit": "mm",
									"value": 30
								}
							}
						}

					},
					"tags": tagValues,

				}
			}
		}
		await dispatch(orders.resetAction({ actionType: 'create' }))
		await dispatch(orders.create({
			url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/confirm-logistics-order`,
			entity: 'orderCreate',
			jsonData: {
				Records: [orderData]
			}
		}))
		await setIsButtonLoading(false)
		await setIsOrderPlaced(true);

	}
	useEffect(() => {
		if (isPaymentAdded) {
			ConfirmOrder()
		}
	}, [isPaymentAdded])
	const encrypt1 = (plainText: string, workingKey: string): string => {
		// Create an MD5 hash of the workingKey
		const key = CryptoJS.MD5(workingKey).toString(CryptoJS.enc.Hex);

		// Initialization vector (IV)
		const iv = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

		// Encrypt the plainText
		const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Hex.parse(key), {
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});

		// Return the encrypted text in hex format
		return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
	};
	const handeCCAvenuePayment = (orderDetails: any) => {
		const workingKey =
			razorpaySettings.CCAvenue?.WorkingKey; //Put in the 32-Bit key shared by CCAvenues.
		const accessCode =
			razorpaySettings.CCAvenue?.AccessCode;
		const merchantId =
			razorpaySettings.CCAvenue?.MerchantId;

		const companyName = localStorage.getItem("CompanyName");
		const channelId = storePersist.get("accessTokenMetadata").current?.TokenMetadata?.SalesChannelId;
		const tenant = companyName; //getBusinessCompanyName();

		// const guestTokenData = {
		// 	Channel: channel.SalesChannelName, //SalesChannelName(),
		// 	Requester: `https://${tenant}.csp.digiit.${process.env.REACT_APP_API_URL}/`,
		// 	StoreId: storeId,
		// 	SalesChannelId: ChannelId,
		// };
		// const accessTokenData = {
		// 	PhoneNumber: userInfo[0]?.PhoneNumber,
		// 	TenantName: tenant,
		// 	SalesChannelId: ChannelId,
		// };
		const ccAvenueData = {
			merchant_id: merchantId,
			order_id: orderDetails?.order?.id,
			currency: 'INR',
			amount: Number(orderDetails?.order?.quote?.price?.value), //Total Price,
			//   ENABLE WHILE TESTING LOCALLY. NEEDS TO BE RUN ALONG WITH PAYMENTS REPO.
			//   redirect_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,
			//   cancel_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,

			// ENABLE FOR PRODUCTION
			redirect_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,
			cancel_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,
			language: 'EN',
			billing_name: orderDetails?.order?.billing?.name,
			billing_address: orderDetails?.order?.billing?.address?.name,
			billing_city: orderDetails?.order?.billing?.address?.city,
			billing_state: orderDetails?.order?.billing?.address?.state,
			billing_zip: orderDetails?.order?.billing?.address?.area_code,
			billing_country: orderDetails?.order?.billing?.address?.country,
			billing_tel: userProfileData?.PhoneNumber,
			billing_email: userProfileData?.Email,
			delivery_name: orderDetails?.order?.fulfillments[0]?.end?.person?.name,
			delivery_address: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.name,
			delivery_city: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.city,
			delivery_state: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.state,
			delivery_zip: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.area_code,
			delivery_country: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.country,
			merchant_param1: tenant, //getOrganizationName(),
			merchant_param2: tenantId,
			merchant_param3: `${window.location.hostname}`,
			merchant_param4: "transport-agent/order-details",
			merchant_param5: '',
			integration_type: 'iframe_normal',
			// promo_code:'PROMO8513',
			customer_identifier: userProfileData?.Email,
		};
		const body = queryString.stringify(ccAvenueData);

		const encRequest1 = encrypt1(body, workingKey);
		// let URL = `https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
		let URL = `https://${MODE}.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;

		window.location.href = URL;
		// router.push(URL);
	}

	useEffect(() => {
		if (isOrderPlaced) {
			switch (selected) {
				case 10: //cash payment
					navigate(`/transport-agent/order-details`)
					break;
				case 20: //online
					switch (paymentGateway[0]?.Id) {
						case 10: //razorpay
							// handeRazorpay()
							break;
						case 20: //ccavenue
							handeCCAvenuePayment(orderDetails?.result?.items?.Records[0]?.message)
							break;
						case 30: //phonepe
							break;
						default:
					}


					break;
				case 30: //wallet
					break;
			}

		}
	}, [isOrderPlaced])
	useEffect(
		() => {
			const localSelectedItems = addNewItemsRow({
				selectedItemsArg: productItems,
			});
			setProductItems(localSelectedItems);
			generateIdValue()
			dispatch(shippingTypes.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {} }))
				.then(() => {
					dispatch(shippingProviders.list({
						url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/shipment-management/shipping-providers/list`, entity: 'shippingProviders', jsonData: {
						}
					}))
				}).then(() => {
					dispatch(products.list({ url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/products/list`, entity: 'products', jsonData: {} }))
				}).then(() => {
					dispatch(variants.list({
						url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/variants/list`, entity: 'variants', jsonData: {}
					}))
				})
				.then(() => {
					dispatch(categories.list({
						url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/categories/list`,
						entity: 'categories',
						jsonData: {}
					}));
				}).then(() => {
					dispatch(paymentMethods.query({
						url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/configuration/payment-management/payment-methods/query-by-tenants`, entity: 'paymentMethods', jsonData:
							{ "Tenants": [{ "Id": tenantId }] }
					}))
				}).then(() => {
					dispatch(channel.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`, entity: 'channels', jsonData: {} }))
				})
		},
		[]
	);
	const handleClose = () => {
		setActiveStep(0)
		SetQuoteData({})
		setProductItems([])
		setPickupLocation({
			name: '',
			lat: '',
			lng: '',
			pincode: '',
			description: ''
		})
		setDropLocation({
			name: '',
			lat: '',
			lng: '',
			pincode: '',
			description: ''
		})
	}
	return (
		<div className="block sm:hidden w-full overflow-auto px-2">
			<div className="max-w-sm mx-auto p-2">
				<div className="border-b p-2 text-center text-xl font-bold">
					{tutorialSteps[activeStep].title}
				</div>

				<div className="w-full flex flex-col p-3 border-b py-5 ">
					<div className="flex flex-col w-full space-y-3">
						{tutorialSteps[activeStep].component}
					</div>
				</div>

				<div className="flex p-3 flex-col space-y-2 pb-20">
					{tutorialSteps[activeStep].id === maxSteps ? (
						<div className="flex flex-col space-y-2">
							<button
								onClick={handleOrder}
								disabled={isButtonLoading}
								className={`${isButtonLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
									} text-light flex items-center justify-center border px-2 py-2 text-sm font-bold w-full sm:w-auto`}
							>
								Confirm Booking
								{isButtonLoading && (
									<div className="ml-2">
										<RotatingLines
											visible={true}
											width="20"
											strokeColor="#fff"
											strokeWidth="6"
											animationDuration="0.75"
											ariaLabel="rotating-lines-loading"
										/>
									</div>
								)}
							</button>
							<button
								disabled={isButtonLoading}
								onClick={handleOrder}
								className="bg-primary text-light border px-2 py-2 text-sm font-bold w-full sm:w-auto"
							>
								Book Later
							</button>
							<button
								disabled={isButtonLoading && activeStep === 1}
								onClick={handleBack}
								className="bg-primary text-light border px-2 py-2 text-sm font-bold w-full sm:w-auto"
							>
								Back
							</button>


						</div>
					) : (
						<div className="flex flex-col space-y-2">
							{tutorialSteps[activeStep].id === 1 && (
								<button
									onClick={handleLeadSubmit}
									disabled={isButtonLoading && activeStep === maxSteps - 1}
									className={`${isButtonLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
										} text-light flex items-center justify-center border px-2 py-2 text-sm font-bold w-full sm:w-auto`}
								>
									Next
									{isButtonLoading && (
										<div className="ml-2">
											<RotatingLines
												visible={true}
												width="20"
												strokeColor="#fff"
												strokeWidth="6"
												animationDuration="0.75"
												ariaLabel="rotating-lines-loading"
											/>
										</div>
									)}
								</button>
							)}

							{tutorialSteps[activeStep].id !== 1 &&
								tutorialSteps[activeStep].id !== 3 && tutorialSteps[activeStep].id !== 5 && (
									<button
										onClick={handleNext}
										disabled={isButtonLoading && activeStep === maxSteps - 1}
										className="bg-primary text-light border px-2 py-2 text-sm font-bold w-full sm:w-auto"
									>
										Next
									</button>
								)}

							{tutorialSteps[activeStep].id === 3 && (
								<button
									onClick={handleSaveQuote}
									disabled={isButtonLoading && activeStep === maxSteps - 1}
									className={`${isButtonLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
										} text-light flex items-center justify-center border px-2 py-2 text-sm font-bold w-full sm:w-auto`}
								>
									Next
									{isButtonLoading && (
										<div className="ml-2">
											<RotatingLines
												visible={true}
												width="20"
												strokeColor="#fff"
												strokeWidth="6"
												animationDuration="0.75"
												ariaLabel="rotating-lines-loading"
											/>
										</div>
									)}
								</button>
							)}
							{activeStep !== 0 && (
								<button
									disabled={isButtonLoading}
									onClick={handleBack}
									className="bg-primary text-light border px-2 py-2 text-sm font-bold w-full sm:w-auto"
								>
									Back
								</button>
							)}


						</div>
					)}
				</div>
			</div>
		</div>


	);
};

export default ParcelBookings;


